window.addEventListener('DOMContentLoaded', () => {
  $('.select2-icon').select2({
    templateResult(state) {
      if (!state.id) {
        return state.text;
      }
      const url = $(state.element).data('iconUrl');
      return $(
        `<div style="display: flex; align-items: center;">
          <img style="padding-right: 1rem;" width="24px" src="${url}" alt="${state.text}" />
          ${state.text}
        </div>`
      );
    }
  });
});
